import React from "react";
import AppointmentPageLayout from "./AppointmentPageLayout";
import AppointmentSchedule from "./components/AppointmentSchedule";
import AppointmentScheduleByCall from "./components/AppointmentScheduleByCall";
import AuthGuard from "pages/Auth/guards/AuthGuard";
const AppointmentPageRoutes = {
    path: 'appointment',
    element: <AppointmentPageLayout />,
    children: [
        { path: '', element: <AuthGuard component={<AppointmentSchedule />} /> },
        { path: 'call-schedule', element: <AppointmentScheduleByCall /> }
    ]
}

export default AppointmentPageRoutes;